import { createContext, useContext, useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import Shiatsu from "@/pages/Shiatsu";
import Yoga from "@/pages/Yoga";
import Aktuelles from "@/pages/Aktuelles";
import UeberMich from "@/pages/UeberMich";
import Kundenstimmen from "@/pages/Kundenstimmen";
import Kontakt from "@/pages/Kontakt";
import Datenschutz from "@/pages/Datenschutz";
import Cookies from "@/pages/Cookies";
import Impressum from "@/pages/Impressum";
import Begleitung from "@/pages/Begleitung";

const LenisContext = createContext(null);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const lenis = useContext(LenisContext);
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
};

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/shiatsu" element={<Shiatsu />} />
        <Route path="/begleitung" element={<Begleitung />} />
        <Route path="/yoga" element={<Yoga />} />
        <Route path="/aktuelles" element={<Aktuelles />} />
        <Route path="/ueber-mich" element={<UeberMich />} />
        <Route path="/kundenstimmen" element={<Kundenstimmen />} />
        <Route path="/kontakt" element={<Kontakt />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/cookies" element={<Cookies />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  const [lenis, setLenis] = useState(null);

  useEffect(() => {
    const instance = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      instance.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    setLenis(instance);
    return () => {
      cancelAnimationFrame(raf);
      instance.destroy();
    };
  }, []);

  return (
    <LenisContext.Provider value={lenis}>
      <BrowserRouter>
        <ScrollToTop />
        <Nav />
        <AnimatedRoutes />
        <Footer />
        <CookieBanner />
      </BrowserRouter>
    </LenisContext.Provider>
  );
}

export default App;
